import React from 'react';
import { FeatureArticleHeader } from './FeatureArticleHeader';
import { StandardArticleHeader } from './StandardArticleHeader';
import { ArticleHeaderProps } from './Types';

export const ArticleHeader = ({
  name,
  image,
  ingress,
  runningHead,
  displayFeatureHeader,
  video,
  youtubeVideo,
  userAccessibility,
  meta,
  metaDisplay,
  isHiddenCategory,
  documentType,
}: ArticleHeaderProps) => {
  if (displayFeatureHeader) {
    return (
      <FeatureArticleHeader
        name={name}
        ingress={ingress}
        runningHead={runningHead}
        image={image}
        video={video}
        videoPlayerOptions={{ autoplay: true, loop: true, muted: true, controls: false }}
        youtubeVideo={youtubeVideo}
        isHiddenCategory={isHiddenCategory}
      />
    );
  }

  return (
    <StandardArticleHeader
      name={name}
      image={image}
      ingress={ingress}
      runningHead={runningHead}
      video={video}
      youtubeVideo={youtubeVideo}
      userAccessibility={userAccessibility}
      meta={meta}
      metaDisplay={metaDisplay}
      documentType={documentType}
    />
  );
};
